<!-- error.component.html -->
 <div class="row" >
    <div class="col-sm-12">
        <div class="error-wrapper mx-auto my-auto" [@fadeIn]>
            <div class="error-container">
              <div class="animation-container">
                <!-- Replace this with a Lottie animation component if desired -->
                <!-- <img src="assets/error-animation.svg" alt="Error Animation" class="error-animation"> -->
                <i class="fa-solid fa-triangle-exclamation error-animation"></i>
              </div>
              <h3>
                {{ errorType === 'route' ? 'Invalid Link' : 'Data Integrity Error' }}
              </h3>
              <p>
                {{ errorType === 'route'
                    ? 'It appears the URL has been tampered with. Please check the link.'
                    : 'Data verification failed. The content might have been altered.' }}
              </p>
              <button (click)="goBack()" class="home-button">Go Back</button>
            </div>
          </div>
    </div>
 </div>
  